<template>
  <div class="container-370 text-center">
    <div class="main-title mb-20 mt-20">
      <p>予約の相手は？（必須）
        <a href="javascript: return void(0);" @click.stop="handleClickHelpModalOfPharmacy()"> 
          <img src="../../../assets/images/icon-question.png">
        </a>
      </p>
    </div>

    <el-select class="select default h-44 w-370 mb-20" value="薬局" disabled />
    
    <div v-if="recentPharmacies && recentPharmacies.length > 0" class="main-title select-pharmacies-main-title mb-20">
          <p>よく選択する薬局はこちら</p>
    </div>
    <ul class="list-option-sub-partner scroll-y-info margin-auto" v-loading="recentPharmacies === null">
      <li
        v-if="recentPharmacies"
        v-for="item in recentPharmacies"
        :key="item.id"
        class="p-15 text-left"
        :class="{selected: selectedPharmacyFromRecent && item.id === selectedPharmacyFromRecent.id}"
        @click="selectPharmacy(item, true)">
        {{item.pmc_name}}
      </li>
    </ul>

    <div class="main-title mt-20 mb-20"><p>他の薬局を選択する？</p></div>

    <el-select
      class="select default h-44 w-370 margin-auto mb-0"
      placeholder="選択してください "
      v-model="selectedPrefecture"
      @change="handleChangePrefecture"
    >
      <el-option label="選択してください " :value="null"/>
      <el-option v-for="item in prefectures" :key="item.id" :label="item.name" :value="item.id"/>
    </el-select>

    <el-select
      class="select default h-44 w-370 margin-auto mb-0 mt-10"
      placeholder="選択してください"
      v-model="selectedCity"
      @change="handleChangeCity"
    >
      <el-option label="選択してください" :value="null"/>
      <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"/>
    </el-select>

    <input @input="handleSearchInputChange" ref="searchInput" type="text" placeholder="店舗名,郵便番号,住所" class="input text margin-auto w-370 mt-10 mb-15 p-15">

    <ul class="list-option-sub-partner mt-15 text-left">
      <li @click="selectPharmacy(pharmacy)"
          :key="pharmacy.id"
          v-for="pharmacy in otherPharmacies.items"
          class="mb-1 pt-12 pl-15"
          :class="{selected: selectedPharmacy && selectedPharmacy.id === pharmacy.id}"
      >
        {{pharmacy.pmc_name}}
      </li>
      <li v-if="otherPharmacies.items.length === 0" class="no-items p-15">該当の薬局が見つかりません</li>
      <infinite-loading @infinite="fetchOtherPharmacies" ref="fetchOtherPharmacies">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </ul>

    <div class="modal-overlay" v-if="showModal">
      <div class="modal">
        <div class="modal-header"></div>
        <div class="modal-body">
          <table class="pt-20 pb-20">
            <tbody>
              <tr>
                <th width="20%">薬局：</th>
                <td align="left">ポケットミーティングを利用したオンライン服薬指導・オンラインカンファレンスに対応している薬局が検索可能です。</td>
              </tr>
            </tbody>
          </table>
          <p class="pb-20">
            <a href="javascript: return void(0);" @click.stop="handlecloseHelpModalOfPharmacy()" class="confirm-btn">閉じる</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PrefecturesApi from '@/api/prefectures'
import PharmaciesApi from '@/api/pharmacies'
import {apiErrorDialog} from '@/helpers'

export default {
  data () {
    return {
      prefectures: [],
      cities: [],
      recentPharmacies: null,
      selectedPharmacyFromRecent: null,
      selectedPharmacy: null,
      selectedPrefecture: null,
      selectedCity: null,
      otherPharmacies: {items: [], params: {page: 1, search_keywords: ''}},
      showModal: false
    }
  },
  props: {
    meeting: {type: Object, required: false}
  },
  methods: {
    async handleChangePrefecture (val) {
      if (val) {
        const prefecture = _.find(this.prefectures, n => n.id === val)
        this.selectedCity = null
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: '', prefecture_id: val}}
        this.selectedPrefecture = val
        this.cities = prefecture.cities
        const params = {...this.otherPharmacies.params, counseling_flg: true, from_pp: true}
        const res = await PharmaciesApi.getAll(params)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
        const pharmacies = res.data.data
        this.otherPharmacies.items = [...this.otherPharmacies.items, ...pharmacies]
      } else {
        this.selectedCity = null
        this.cities = []
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: ''}}
      }
      this.$refs.searchInput.value = ''
    },
    handleSearchInputChange: _.debounce(function (e) {
      this.selectedPharmacy = null
      if (!this.selectedPrefecture) {
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: e.target.value}}
      }
      if (this.selectedPrefecture && !this.selectedCity) {
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: e.target.value, prefecture_id: this.selectedPrefecture}}
      }
      if (this.selectedPrefecture && this.selectedCity) {
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: e.target.value, prefecture_id: this.selectedPrefecture, city_id: this.selectedCity}}
      }
      this.$refs.fetchOtherPharmacies.stateChanger.reset()
    }, 500),
    async handleChangeCity (val) {
      if (val) {
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: '', prefecture_id: this.selectedPrefecture, city_id: val}}
        this.selectedCity = val
      } else {
        this.otherPharmacies = {items: [], params: {page: 1, search_keywords: '', prefecture_id: this.selectedPrefecture}}
        this.selectedCity = null
      }
      const params = {...this.otherPharmacies.params, counseling_flg: true, from_pp: true}
      const res = await PharmaciesApi.getAll(params)
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      const pharmacies = res.data.data
      this.otherPharmacies.items = [...this.otherPharmacies.items, ...pharmacies]
      this.$refs.searchInput.value = ''
    },
    selectPharmacy (pharmacy, fromRecentList = false) {
      if (!fromRecentList) {
        this.selectedPharmacy = _.find(this.otherPharmacies.items, n => n.id === pharmacy.id)
        this.selectedPharmacyFromRecent = null
        this.$emit('input', this.selectedPharmacy)
      } else {
        this.selectedPharmacyFromRecent = _.find(this.recentPharmacies, n => n.id === pharmacy.id)
        this.selectedPharmacy = null
        this.$emit('input', this.selectedPharmacyFromRecent)
      }
    },
    async fetchRecentPharmacies () {
      const res = await PharmaciesApi.getRecents({from_pp: true})
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      this.recentPharmacies = res.data.data

      if (this.meeting) {
        const index = _.findIndex(this.recentPharmacies, n => n.id === this.meeting.pharmacy.id)
        this.selectedPharmacyFromRecent = this.recentPharmacies[index]
      }

    },
    async fetchPrefectures () {
      const res = await PrefecturesApi.getAll()
        .catch((error) => apiErrorDialog(this, error))
      this.prefectures = res.data.data
    },
    async remoteMethod (query) {
      let params = {counseling_flg: true, from_pp: true}
      if (this.selectedPrefecture) params.prefecture_id = this.selectedPrefecture
      if (this.selectedCity) params.city_id = this.selectedCity
      if (query.trim() !== '') params.search_keywords = query
      const res = await PharmaciesApi.getAll(params)
        .catch((error) => apiErrorDialog(this, error))
      this.pharmacies = res.data.data
    },
    async fetchOtherPharmacies ($state) {
      if (
        typeof this.otherPharmacies.params.prefecture_id !== 'undefined'
        ||  this.otherPharmacies.params.search_keywords.trim() !== '') {
        const params = {...this.otherPharmacies.params, counseling_flg: true, from_pp: true}
        const res = await PharmaciesApi.getAll(params)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
        const pharmacies = res.data.data
        const pagination = res.data.meta.pagination
        this.otherPharmacies.items = [...this.otherPharmacies.items, ...pharmacies]
        if (!pagination.has_more_pages) return $state.complete()
        this.otherPharmacies.params.page++
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    handleClickHelpModalOfPharmacy () {
      this.showModal = true
    },
    handlecloseHelpModalOfPharmacy () {
      this.showModal = false
    }
  },
  mounted () {
    this.fetchRecentPharmacies()
    this.fetchPrefectures()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/SelectPharmacies.vue